/* Top-5-vergelijking (mv-top5-lijst): de extra kaarten open- en dichtklappen. De labels komen uit de
   sectie-instellingen (data-meer / data-minder op de knop). */
(() => {
  if (window.mvTop5Meer) return;
  window.mvTop5Meer = true;
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-t5-meer]');
    if (!knop) return;
    const vak = document.getElementById(knop.getAttribute('aria-controls'));
    if (!vak) return;
    const open = knop.getAttribute('aria-expanded') !== 'true';
    vak.hidden = !open;
    knop.setAttribute('aria-expanded', String(open));
    const label = knop.querySelector('[data-t5-label]');
    if (label) label.textContent = open ? knop.dataset.minder : knop.dataset.meer;
  });
})();
